import React from "react"
import { css } from "styled-components"

const Quiz = () => (
  <iframe
    title="Mennyire ismered a Soproni Egyetemet?"
    src="https://docs.google.com/forms/d/e/1FAIpQLSc5PNXbpkjJk8RtVyjKxPDkhznlCy5ZYAED4abcOkawHsSVgA/viewform?embedded=true"
    frameborder="0"
    marginheight="0"
    marginwidth="0"
    css={css`
      width: calc(100% - 20px);
      height: calc(100% + 40px);
      position: absolute;
      left: 0;
      top: 0;
    `}
  >
    Betöltés…
  </iframe>
)

export default Quiz
